var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import linkedCardService from "@irati/perksgo/services/linkedcards";
import authentication from "@irati/auth";
import { hangPromise } from "@irati/utils/promise";
import Loading from "@irati/ui/src/Loading";
import { LangLoader } from "@irati/utils/lang";
import { PERKSGO } from "@irati-web/app/src/routeConfig";
import perksGOTracking from "@irati-tracking/perksgo/perksGO";
import ModalLocation from "@irati-tracking/perksgo/enums/ModalLocation";
import HasCardBlock from "./HasCardBlock";
import NoCardsBlock from "./NoCardsBlock";
import FindOutMorePopup from "../Popup/FindOutMore";
import { PerksGOBackground, PerksGOWrapper } from "./styled";
var PerksGOImportantInfo = /** @class */ (function (_super) {
    __extends(PerksGOImportantInfo, _super);
    function PerksGOImportantInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.findOutMorePopup = React.createRef();
        _this.state = {
            load: hangPromise(),
            hasLinkedCards: undefined
        };
        _this.componentDidMount = function () {
            _this.setState({ load: _this.hasLinkedCards() });
        };
        _this.hasLinkedCards = function () {
            var userId = authentication.user().uuid;
            return linkedCardService.getPerksGOCards({ userId: userId }).then(function (linkedCards) {
                _this.setState({ hasLinkedCards: linkedCards.length > 0 });
            });
        };
        _this.showModal = function () {
            perksGOTracking.showFindOutMoreModal(ModalLocation.DealImportantInfo);
            _this.findOutMorePopup.current.show();
        };
        return _this;
    }
    PerksGOImportantInfo.prototype.render = function () {
        var deal = this.props.deal;
        var _a = this.state, load = _a.load, hasLinkedCards = _a.hasLinkedCards;
        return (React.createElement(LangLoader, { bucket: PERKSGO },
            React.createElement(PerksGOBackground, null,
                React.createElement(PerksGOWrapper, { direction: "column", padding: "30px 20px" },
                    React.createElement(Loading, { load: load }, hasLinkedCards ?
                        React.createElement(HasCardBlock, { isPerksGoRetailDeal: deal === null || deal === void 0 ? void 0 : deal.isPerksGoRetailDeal, dealExternalLinks: deal === null || deal === void 0 ? void 0 : deal.externalLinks }) :
                        React.createElement(NoCardsBlock, { showModal: this.showModal })),
                    React.createElement(FindOutMorePopup, { ref: this.findOutMorePopup, isInDeal: true, modalLocation: ModalLocation.DealImportantInfo })))));
    };
    return PerksGOImportantInfo;
}(PureComponent));
export default PerksGOImportantInfo;
